module.exports = ".drx-pagination {\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  -webkit-box-pack: end !important;\n      -ms-flex-pack: end !important;\n          justify-content: flex-end !important;\n  list-style: none !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/pagination/pagination.component.scss
// module id = ./src/app/components/pagination/pagination.component.scss
// module chunks = main